import useProfiler from "../../../hooks/useProfiler";
import { createTrackingUtils } from "../index";
import { useCallback, useMemo } from "react";
import useRouteName from "../../../hooks/useRouteName";
import { useSelector } from "react-redux";
import { type StoreState } from "../../../store";

const util = createTrackingUtils({
  name: "flights_aa_web_funnel_searchresult_traffic_fe",
  defaultStage: 1,
  stages: {
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6,
    seven: 7,
    eight: 8,
    nine: 9
  },
  goals: {},
  goalsWithValue: []
});

export default function useFlightsAaWebFunnelSearchresutlTrafficFe() {
  const { isDesktop, isMeta } = useProfiler();
  const routeName = useRouteName();
  const flightOffers = useSelector((s: StoreState) => s.searchResults?.flights);

  const isRyanair = useMemo(() => {
    return flightOffers?.some((o) => {
      return o.segments.some((s) => {
        return s.legs.some((l) => {
          return (
            l.flightInfo.carrierInfo?.marketingCarrier?.toLocaleLowerCase() === "rk" ||
            l.flightInfo.carrierInfo?.marketingCarrier?.toLocaleLowerCase() === "fr" ||
            l.carriers.includes("RK") ||
            l.carriers.includes("FR") ||
            l.carriers.includes("rk") ||
            l.carriers.includes("fr")
          );
        });
      });
    });
  }, [flightOffers]);

  const trackStages = useCallback(() => {
    if (!isRyanair) return;
    if (routeName !== "searchresults") return;
    util.trackWithDefaultStage();
    util.stages.one();
    if (!isMeta()) {
      util.stages.two();
      if (isDesktop()) {
        util.stages.four();
        util.stages.six();
      } else {
        util.stages.five();
        util.stages.seven();
      }
    } else {
      util.stages.three();
      if (isDesktop()) {
        util.stages.four();
        util.stages.eight();
      } else {
        util.stages.five();
        util.stages.nine();
      }
    }
  }, [isRyanair, routeName, isDesktop, isMeta]);

  return { trackStages };
}
